// src/plugins/calm-kit.js
//
// Calm Kit (Element V2) — registers every Calm Kit component globally so v2
// pages can use <calm-page>, <calm-modal>, <calm-table>, … without per-file
// imports. Additive: registering these components does not affect any v1 page
// (they only render where authored). Styles live in src/assets/scss/v2/calm.scss
// (imported by dashboard-plugin.js) — this file is JS registration only.
//
// NOTE: clientPaginationMixin is NOT bundled here — pages keep importing it
// from src/views/Lmg/PaginatedTables/clientPaginationMixin.js as before.

// Shell / page / inputs.
import CalmPage from "@/components/lmg/CalmPage.vue";
import CalmButton from "@/components/lmg/CalmButton.vue";
import CalmFilterBar from "@/components/lmg/CalmFilterBar.vue";
import CalmField from "@/components/lmg/CalmField.vue";

// Overlays / table / form.
import CalmModal from "@/components/lmg/CalmModal.vue";
import CalmTable from "@/components/lmg/CalmTable.vue";
import CalmFormSection from "@/components/lmg/CalmFormSection.vue";
import CalmFormRow from "@/components/lmg/CalmFormRow.vue";

// Existing — reuse, don't redefine.
import CalmIcon from "@/components/lmg/CalmIcon.vue";

const CalmKit = {
  install(Vue) {
    // guard against double-install
    if (CalmKit.installed) return;
    CalmKit.installed = true;

    Vue.component(CalmPage.name || "calm-page", CalmPage);
    Vue.component(CalmButton.name || "calm-button", CalmButton);
    Vue.component(CalmFilterBar.name || "calm-filter-bar", CalmFilterBar);
    Vue.component(CalmField.name || "calm-field", CalmField);

    Vue.component(CalmModal.name || "calm-modal", CalmModal);
    Vue.component(CalmTable.name || "calm-table", CalmTable);
    Vue.component(CalmFormSection.name || "calm-form-section", CalmFormSection);
    Vue.component(CalmFormRow.name || "calm-form-row", CalmFormRow);

    Vue.component(CalmIcon.name || "calm-icon", CalmIcon);
  },
};

export default CalmKit;
